// Import database client
import databaseClient from '../databaseClient';

// ------------------------------------------------------------------------------
// GETTER
// ------------------------------------------------------------------------------
// Generate an id for the visit
export async function generateVisitId() {
    const { data, error } = await databaseClient.rpc(
        'generate_unique_visit_id',
    );

    if (error) {
        throw error;
    }

    return data;
}

// Get visit count per day
export async function getVisitPerDayCount() {
    const { data, error } = await databaseClient.rpc('get_visit_count_per_day');

    if (error) {
        throw error;
    }

    return data;
}

// Get view per product count
export async function getViewPerProductCount() {
    const { data, error } = await databaseClient.rpc(
        'get_view_count_per_product',
    );

    if (error) {
        throw error;
    }

    return data;
}

// Get view per location count
export async function getViewPerLocationCount() {
    const { data, error } = await databaseClient.rpc(
        'get_visit_count_per_location',
    );

    if (error) {
        throw error;
    }

    return data;
}

// ------------------------------------------------------------------------------
// LOGGER
// ------------------------------------------------------------------------------
// Log the visit in the db
export async function logVisit(visitId) {
    const response = await databaseClient.functions.invoke('log_visit', {
        body: { visit_id: visitId },
    });

    if (response.error) {
        throw response.error;
    }
}

// Log a vue for a given product
export async function logProductView(visitId, productId) {
    const response = await databaseClient.functions.invoke('log_product_view', {
        body: {
            visit_id: visitId,
            product_id: productId,
        },
    });

    if (response.error) {
        throw response.error;
    }
}
